import React from 'react';

const SimplePublicPage = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Public Page</h1>
      <p className="mb-4">This is a simple public page that anyone can access without logging in.</p>
      
      <div className="bg-blue-100 border-l-4 border-blue-500 p-4 mb-6">
        <p className="text-blue-700">
          This page is being displayed without any authentication requirements.
        </p>
      </div>
      
      <h2 className="text-xl font-semibold mb-2">Sample Brands</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {['Microsoft', 'Apple', 'Google', 'Amazon', 'Facebook', 'Twitter'].map(brand => (
          <div key={brand} className="bg-white p-4 rounded shadow">
            <h3 className="font-medium">{brand}</h3>
            <p className="text-gray-600 text-sm">{brand.toLowerCase()}.com</p>
          </div>
        ))}
      </div>
      
      <div className="mt-8 text-center">
        <a 
          href="/" 
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 inline-block"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default SimplePublicPage; 